import axios from "../../utils/axios";

export const getUnlikes = async (id) => {
  const response = await axios.get(`/videos/${id}`);
  const newResponse = await axios.patch(`/videos/${id}`, {
    ...response?.data,
    unlikes: response?.data?.unlikes + 1,
  });
  return newResponse?.data;
};
